import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { IColumnProps } from 'components/TableComponent';
import CardServer from './_components/CardServer';
import { ON_PREMISE_MANAGEMENT_ENDPOINT } from 'services/OnPremiseManagementStatusService';
import { IOnPremiseManagementStatusProps } from 'services/OnPremiseManagementStatusService/types';
import { getStreamByEndpointAsync } from 'services/Events';

const ServersPage = () => {
  const [onPremiseManagementStatus, setOnPremiseManagementStatus] = useState<
    IOnPremiseManagementStatusProps[]
  >([]);

  useEffect(() => {
    getStreamByEndpointAsync(
      ON_PREMISE_MANAGEMENT_ENDPOINT + '/status',
      setOnPremiseManagementStatus,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    );
  }, []);

  const columns: IColumnProps[] = [
    { id: 'description', label: 'Descrição', width: '100%' },
    { id: 'device.name', label: 'Dispositivo', width: '100%' },
    {
      id: 'createdAt',
      label: 'Data/Hora',
      width: '0%',
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  return (
    <>
      <Box display="flex" flexDirection="column" gap={2} width="100%">
        {onPremiseManagementStatus.length === 0 ? (
          <Box width="100%" textAlign="center" py={4}>
            Nenhum servidor encontrado.
          </Box>
        ) : (
          <Grid container spacing={2}>
            {[...onPremiseManagementStatus]
              .sort((a, b) => {
                const aOnline = a.isOnlineApi || a.isOnlineDeviceServer;
                const bOnline = b.isOnlineApi || b.isOnlineDeviceServer;
                if (aOnline === bOnline) return 0;
                return aOnline ? -1 : 1;
              })
              .map((event, eventIndex) => (
                <Grid item xs={12} sm={6} md={4} key={eventIndex}>
                  <CardServer
                    onPremiseManagementStatusId={event.id}
                    device={event.devices[0]}
                    allDevices={event.devices}
                    isOnlineApi={event.isOnlineApi}
                    isOnlineDeviceServer={event.isOnlineDeviceServer}
                    onPremiseLicenseId={event.onPremiseLicenseId}
                  />
                </Grid>
              ))}
          </Grid>
        )}
      </Box>
    </>
  );
};

export default ServersPage;
